import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { clsx } from "clsx";

/** Renders an announcement body (Markdown from the AI changelog) as formatted text.
 *  `compact` trims spacing for the dashboard widget. */
export function AnnouncementBody({
  text,
  className,
}: {
  text: string;
  className?: string;
}) {
  return (
    <div
      className={clsx(
        "text-sm leading-relaxed break-words text-[var(--text-primary)]",
        "[&_h1]:text-base [&_h1]:font-semibold [&_h1]:mt-3 [&_h1]:mb-1",
        "[&_h2]:text-sm [&_h2]:font-semibold [&_h2]:mt-3 [&_h2]:mb-1",
        "[&_h3]:text-sm [&_h3]:font-semibold [&_h3]:mt-3 [&_h3]:mb-1 [&_h3]:uppercase [&_h3]:tracking-wide [&_h3]:text-[var(--text-muted)]",
        "[&_p]:my-1 [&_strong]:font-semibold",
        "[&_ul]:my-1 [&_ul]:list-disc [&_ul]:pl-5 [&_ol]:my-1 [&_ol]:list-decimal [&_ol]:pl-5 [&_li]:my-0.5",
        "[&_a]:text-[var(--color-primary)] [&_a]:underline",
        "[&_code]:rounded [&_code]:bg-black/5 [&_code]:px-1",
        className,
      )}
    >
      <ReactMarkdown remarkPlugins={[remarkGfm]}>{text}</ReactMarkdown>
    </div>
  );
}
